






































































































































































































































































































































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import Slider from '@/product/components/Slider.vue'
import HowToDesign from '@/product/components/HowToDesign.vue'
import ProductDetails from '@/product/components/ProductDetails.vue'
import OrderFlow from '@/product/components/OrderFlow.vue'
import QuantitySelect from '@/product/components/QuantitySelect.vue'
import PrintingOptions from '@/product/components/PrintingOptions.vue'
import EstimatePrice from '@/product/components/EstimatePrice.vue'
import EstimateInvoice from '@/product/components/EstimateInvoice.vue'
import ProductOptions from '@/product/components/ProductOptions.vue'
import OrderUnitInfo from '@/product/components/OrderUnitInfo.vue'
import PriceTable from '@/product/components/PriceTable.vue'
import OrderMethod from '@/product/components/OrderMethod.vue'
import SimilarProducts from '@/product/components/SimilarProducts.vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import ContactLink from '@/product/components/ContactLink.vue'
import PrintableColors from '@/product/components/PrintableColors.vue'
import GifteeBanner from '@/product/components/GifteeBanner.vue'
import Skeleton from '@/common/components/Skeleton.vue'
import QuickDeliverySection from '@/product/components/QuickDeliverySection.vue'
import DeliveryOptions from '@/product/components/DeliveryOptions.vue'
import Modal3DModel from '@/common/components/Modal3DModel.vue'
import { QUICK_DELIVERY_PRODUCTS } from '@/product/const'
import { BQ_AWS_PERSONALIZE_LOGIC_TYPE, BQ_AWS_PERSONALIZE_PAGE_TYPE, BQ_EVENT_NAMES, raksulBQEventTracker } from '@/common/utils'
import DeliveryDateModal from '@/product/components/DeliveryModal.vue'
import CarouselProductHorizontal from '@/common/components/carouselProducts/CarouselProductHorizontal.vue'
import FavoriteBtn from '@/common/components/FavoriteBtn.vue'
import FavoriteBtnPopup from '@/common/components/FavoriteBtnPopup.vue'
import { Snackbar } from '@raksul/raksul-common-ui'
import { PERSONALIZE_PATTERNS, PERSONALIZE_PAGES, PERSONALIZE_AREAS } from '@/common/const'

export default Vue.extend({
  components: {
    Slider,
    HowToDesign,
    ProductDetails,
    OrderFlow,
    QuantitySelect,
    PrintingOptions,
    EstimatePrice,
    EstimateInvoice,
    ProductOptions,
    PriceTable,
    OrderUnitInfo,
    OrderMethod,
    SimilarProducts,
    SectionTitle,
    ContactLink,
    PrintableColors,
    GifteeBanner,
    Skeleton,
    QuickDeliverySection,
    DeliveryOptions,
    DeliveryDateModal,
    Modal3DModel,
    CarouselProductHorizontal,
    FavoriteBtn,
    FavoriteBtnPopup,
    Snackbar
  },
  props: {
    isMobileLayout: {
      type: Boolean
    }
  },
  data(): {
    customClass: string
    disabledLoading: boolean,
    isFirstLoad: boolean,
    isDeliveryModalVisible: boolean,
    openSnackbar: boolean,
    snackbarTimeout: any
  } {
    return {
      customClass: '',
      disabledLoading: false,
      isFirstLoad: true,
      isDeliveryModalVisible: false,
      openSnackbar: false,
      snackbarTimeout: null
    }
  },
  computed: {
    ...mapGetters([
      'estimate',
      'product',
      'estimateQuantity',
      'fullRequestQueries',
      'wrappingSelectedOption',
      'selectedColorPatternOption',
      'selectedEditPattern',
      'skuImageView',
      'currentSKUImageView',
      'is3DModalOpen'
    ]),
    routerQueries() {
      return {
        ...this.$route.query,
        psi: this.estimate.printable_sku_id,
        quantity: this.estimateQuantity,
        trial: this.estimate.trial,
        plain: this.estimate.plain_good
      }
    },
    productId() {
      return this.$route.params.id
    },
    isLoadedProduct(): boolean {
      return this.product && this.product.product_id
    },
    isProductOptionVisible() : boolean {
      return this.product.first_options.length > 0 ||
        this.product.second_options.length > 0 ||
        (this.product.wrapping_options.length > 1 && this.wrappingSelectedOption.id)
    },
    printingSpecific() {
      const printingIndex = this.isProductOptionVisible ? 3 : 2
      return {
        show: (this.product.color_pattern_options.length > 0  && this.selectedColorPatternOption)
          || (this.product.edit_pattern_options.length > 0 && this.selectedEditPattern),
        index: this.hasValidDeliveryOption ? printingIndex + 1 : printingIndex
      }
    },
    finalStepIndex(): number {
      const checkOptionSpecific = (this.isProductOptionVisible || this.printingSpecific.show) ? 3 : 2
      const finalIndex = (this.isProductOptionVisible && this.printingSpecific.show) ? 4 : checkOptionSpecific
      return this.hasValidDeliveryOption ? finalIndex + 1 : finalIndex
    },
    isRefreshingProduct(): boolean {
      if (this.product?.product_id) {
        return this.$store.state.productLoading && !this.disabledLoading
      }
      return false
    },
    isShowInProductOptions(): boolean {
      return this.isProductOptionVisible && !this.printingSpecific.show
    },
    isShowInMethodOptions(): boolean {
      return !this.printingSpecific.show && !this.isShowInProductOptions
    },
    isGifteeProduct(): boolean {
      return this.product.giftee || false
    },
    isGifteeProductWithBanner(): boolean {
      return this.product.giftee_show_banner || false
    },
    isQuickDeliveryProduct(): boolean {
      return Object.keys(QUICK_DELIVERY_PRODUCTS).includes(this.product.product_id.toString())
    },
    isNormalDeliveryProduct(): boolean {
      return Object.values(QUICK_DELIVERY_PRODUCTS).includes(this.product.product_id.toString())
    },
    hasQuickDeliveryOption(): boolean {
      return this.product.has_quick_delivery_option && this.product.setting_quick_delivery_change_ui
    },
    hasValidDeliveryOption(): boolean {
      return this.hasQuickDeliveryOption && this.$store.state.delivery_options.length > 0
    },
    isQuickDeliveryFirstOption(): boolean {
      return this.hasQuickDeliveryOption && this.product.setting_quick_delivery_is_first_option
    },
    isQuickDeliverySecondOption(): boolean {
      return this.hasQuickDeliveryOption && this.product.setting_quick_delivery_is_second_option
    },
    productIndex(): number {
      return this.hasValidDeliveryOption ? 2 : 1
    },
    PERSONALIZE_PATTERNS() {
      return PERSONALIZE_PATTERNS
    },
    PERSONALIZE_PAGES() {
      return PERSONALIZE_PAGES
    },
    PERSONALIZE_AREAS() {
      return PERSONALIZE_AREAS
    },
    BQ_AWS_PERSONALIZE_LOGIC_TYPE() {
      return BQ_AWS_PERSONALIZE_LOGIC_TYPE
    },
    BQ_AWS_PERSONALIZE_PAGE_TYPE() {
      return BQ_AWS_PERSONALIZE_PAGE_TYPE
    }
  },
  created() {
    const { psi, quantity, trial, plain, trackSourceSection, trackSourceSectionProductIndex, trackProductPerRow } = this.$route.query

    const { id } = this.$route.params
    const hasParams = !!psi
    if (plain == 'true') {
      this.$store.commit('setIsOrderPlainProduct', true)
    }

    if (hasParams) {
      this.getEstimateByPsi({ param: psi, queries: { quantity, trial }})
        .then(() => {
          const isPlainPsi = this.estimate.plain_good
          this.$store.commit('setIsOrderPlainProduct', isPlainPsi)
          this.refreshProductInfo({
            param: id
          }, false)
        })
        .catch(() =>
          this.refreshProductInfo({ param: id, queries: {}, keepRoute: false })
        )
    } else {
      this.refreshProductInfo({ param: id, queries: {}, keepRoute: false })
    }

    if (document.referrer.includes(`${window.location.origin}/search`)) {
      this.trackingProductClickFromSearch(id)
    }

    if (trackSourceSection && trackSourceSectionProductIndex) {
      const productPerRow = trackProductPerRow ?? 4
      let sectionRowNumber
      if (trackProductPerRow) {
        sectionRowNumber = Math.floor((Number(trackSourceSectionProductIndex)) / Number(productPerRow)) + 1
      } else {
        sectionRowNumber = Math.floor((Number(trackSourceSectionProductIndex) - 1) / Number(productPerRow)) + 1
      }
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.CLICK_PRODUCT_CATEGORY,
        data: {
          productId: id,
          sectionName: trackSourceSection,
          sectionRowNumber: sectionRowNumber.toString()
        }
      })
      const queryParamsObj = {...this.$route.query}
      delete queryParamsObj.trackSourceSection
      delete queryParamsObj.trackSourceSectionProductIndex
      this.$router.replace({query: queryParamsObj})
    }
  },
  methods: {
    ...mapActions([
      'getEstimateByPsi',
      'getProduct'
    ]),
    refreshProductInfo(payload) {
      const inputData = payload || {}
      const { param, queries , loadImageView, keepRoute, disabledLoading } = inputData
      const psi = this.estimate.printable_sku_id
      this.disabledLoading = disabledLoading ? true : false
      this.getProduct({
        param: param || this.product.product_id,
        loadImageView: loadImageView || false,
        queries: queries || this.fullRequestQueries
      })
        .then(() => !keepRoute && this.$router.push({ query: this.routerQueries }))
        .then(() => {
          this.isFirstLoad = false
          if (this.isQuickDeliveryFirstOption) {
            this.$store.commit('setDeliveryOptions', this.product.first_options)
            this.$store.commit('setFirstOptions',[])
          }
          if (this.isQuickDeliverySecondOption) {
            this.$store.commit('setDeliveryOptions',this.product.second_options)
            this.$store.commit('setSecondOptions',[])
          }
          if (psi !== this.estimate.printable_sku_id || !this.$store.getters.priceTable) {
            this.$store.dispatch('getPriceTable')
          }
        }).catch(() => {
          this.isFirstLoad = false
        })
    },
    setFirstSlideImage(firstSKUId: number) {
      this.$refs?.productSlider?.onHoverSliderImage(firstSKUId)
    },
    setImageDescription(caption: string) {
      this.$refs.productSlider.changeImageDescription(caption)
    },
    trackingProductClickFromSearch(productId: string) {
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.SEARCH_RESULT_CLICK,
        data: {
          productId: productId
        }
      })
    },
    quickDeliveryLink(productId: number): string {
      if (this.isQuickDeliveryProduct) {
        return `/products/${QUICK_DELIVERY_PRODUCTS[productId]}`
      }
      else {
        let normalDeliveryProductId = Object.keys(QUICK_DELIVERY_PRODUCTS).find(id => QUICK_DELIVERY_PRODUCTS[id] === productId.toString())
        return `/products/${normalDeliveryProductId}`
      }
    },
    handleValidateQuantity() {
      this.$refs?.quantitySelect?.$refs.quantityInput.validateQuantity(this.estimateQuantity)
    },
    closeDeliveryDateModal() {
      this.isDeliveryModalVisible = false
    },
    openDeliveryDateModal() {
      this.isDeliveryModalVisible = true
    },
    scheduleSnackbarHide() {
      this.snackbarTimeout = window.setTimeout(() => {
        this.openSnackbar = false
      }, 3000)
    },
    handleSnackbar() {
      if (this.openSnackbar === false) {
        this.openSnackbar = true
        this.scheduleSnackbarHide()
      } else {
        window.clearTimeout(this.snackbarTimeout)
        this.openSnackbar = false
        window.setTimeout(() => {
          this.openSnackbar = true
          this.scheduleSnackbarHide()
        }, 200)
      }
    },
    close3DModal() {
      this.$store.commit('setIs3DModalOpen', false)
    }
  }
})
